export default __webpack_public_path__ + "static/media/edit.14a99b40.svg";